import { adminHttpClient } from '../../commons/adminHttpClient'

export type PremiumPlusQueryResponse = {
  showPopup: boolean
  productClassId: string
}
const getShowPopupForPremiumPlus = (planPeriodId?: string | undefined): Promise<PremiumPlusQueryResponse> => {
  return adminHttpClient.get(`/admindashboard/benefit/showpopupforpremiumplus`)
}

export default getShowPopupForPremiumPlus
